import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";
declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-mentee-feedback",
  templateUrl: "./mentee-feedback.component.html",
})
export class MenteeFeedbackComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  @ViewChild("datePicker", { static: false })
  datePicker: ElementRef;
  startDate: any = "";
  endDate: any = "";
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtTrigger = new Subject();
  menteeFeedbackArr: any = []; // Table Data list
  exportMenteeList: any = [];
  fieldsToIncludeExcel: any = [];
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = "";

  totalMenteeFeedbacks: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;

  exl: boolean = false;

  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private excelService: ExcelService,
    private dataService: MentorshipDashboardService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate;
    this.endDate = endDate;
    this.getListing();
    this.menteeFeedbackListing();
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "mentee_feedback",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.menteeFeedbackArr = resp["data"];
            this.totalMenteeFeedbacks = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "meeting_topic" },
        { data: "feedback" },
        { data: "created_at" },
      ],
    };
  }

  menteeFeedbackListing() {
    const data = {
      draw: 1,
      start: 0,
      length: 1,
      order: [
        {
          column: 0,
          dir: "asc",
        },
      ],
      search: {
        value: "",
        regex: false,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "mentee_feedback",
    };

    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportMenteeList = res["data"];
        this.fieldsToIncludeExcel = [
          "name",
          "meeting_topic",
          "feedback",
          "created_at",
        ];
        this.exl = true;

        this.loadHide();
      });
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#mentee_feedback").DataTable();
    table.ajax.reload(null, false);
    this.menteeFeedbackListing();
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    const table = $("#mentee_feedback").DataTable();
    table.ajax.reload(null, false);
    this.menteeFeedbackListing();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $("#mentee_feedback").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  ngOnDestroy(): void {
    $("#mentee_feedback").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault(); 
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportMenteeList,
      this.fieldsToIncludeExcel,
      "Mentee Feedbacks"
    );
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
